import React from 'react';

import styles from './Activity.module.css';

import { GridItem } from '../../Grid/Grid';
import { Link } from '../../Link/Link';

export interface ActivityProps {
  hasBeenViewed?: boolean;
  href: string;
  pageId?: number;
  text?: string;
  title: string;
  type?: string;
}

export function Activity({ href, title, type = '', text = 'Visit', hasBeenViewed }: ActivityProps): JSX.Element {
  const status = hasBeenViewed ? `Unlocked ${type}` : `Locked ${type}`;

  const urlParamKeys = {
    'My Insight Diary': 'insight-diary',
    'Alc-ulator': 'alc-ulator',
    'Drinking Diary': 'drinking-diary',
    'My Experiment': 'my-experiment',
  };

  const url = href === '/etools/calendar' ? `${href}?tab=${urlParamKeys[title]}` : href;

  return (
    <GridItem sizes={['sml-1', 'med-2', 'lrg-4']}>
      <Link href={url} isDisabled={!hasBeenViewed}>
        <div className={`${hasBeenViewed ? `card ${styles['card--complete']}` : 'card'}`}>
          <img alt="Locked" className={`m-b--large ${styles.locker} ${!hasBeenViewed && 'filter-grey'}`} src="/SVG/lock.svg" />
          <p className="h5 h-color--navy m-b">{status}</p>
          <h2 className="h-color--black m-b--large">{title}</h2>
          <p className="h4 h-color--navy">{text}</p>
        </div>
      </Link>
    </GridItem>
  );
}
